import React, { Component } from 'react'
import { className } from 'classnames';
import { AiOutlineCloseCircle, AiOutlinePlusCircle, AiOutlinePlus, } from "react-icons/ai";

export default class Overlay extends Component {
    render() {
        const { hideOverlay, children, styles, roundCross, darkOverlay } = this.props;

        return ( 
            <div className={darkOverlay ? 'darkOverlay' : "overlay"}>
                {
                    hideOverlay && !roundCross && <div className="overlay-container">
                        <span className="overlay-close-button fs-20 mt-20" onClick={hideOverlay}>
                            X
                        <AiOutlineCloseCircle size="2em" onClick={this.props.close} />
                        </span>
                    </div>
                }

                {
                    roundCross && <div className="overlay-container">
                        <span className="overlay-close-button fs-20 mt-20" style={{marginRight: '6%', marginTop: '2%'}}>
                            <AiOutlineCloseCircle size="2em" onClick={hideOverlay} />
                        </span>
                    </div>
                }

                
                <div style={styles} className="overlay-body br-5 bg-white wt-100p ht-overlay-body center pa">
                         { children }
                    </div>
            </div>
        )
    }
}
